export default "__VITE_ASSET__def1b8da__"